export const locale = {
  lang: 'es',
  data: {
    'PERFIL_USUARIO': {
      'TITULO': 'Mi perfil',
      'ENLACES': {
        'configuracion': 'Configuración de la cuenta',
        'notificaciones': 'Notificaciones del usuario',
        'mensajes': 'Mensajes recibidos'
      },
      'PAGINAS': {
        'configuracion': {
          'TITULO': 'Configuración de la cuenta',
          'OPCIONES': {
            'CAMBIARMAIL': {
              'TITULO': 'Cambiar correo electrónico',
              'SUBTITULO': 'Puede cambiar la dirección de correo electrónico de su cuenta',
              'INPUTS': {
                'MAIL': 'Nueva dirección de correo electrónico',
                'TOKEN': 'Código de verificación',
                'PASS': 'Nueva contraseña',
                'CONFIRMPASS': 'Confirmar contraseña'
              },
              'BOTONES': {
                'CAMBIAMAIL': 'Cambiar correo',
                'VERTOKEN': 'Verificar código',
                'FINALMAIL': 'Cambiar dirección de correo electrónico',
              }
            },
            'CAMBIARPASS': {
              'TITULO': 'Cambiar contraseña',
              'SUBTITULO': 'Puede cambiar la contraseña de su cuenta',
              'BOTONES': {
                'FINALPASS': 'Cambiar contraseña'
              }
            },
            'AUTENTICACION': {
              'TITULO': 'Autenticación de dos pasos',
              'SUBTITULO': 'Puede incrementar la seguridad de su cuenta activando la autenticación de dos pasos',
              'BOTONES': {
                'ACTIVAR': 'Activar',
                'DESACTIVAR': 'Desactivar'
              }
            }
          }
        }
      },
      'MODALES': {
        'CAMBIARMAIL_PASO1_OK': 'Se ha enviado un mensaje al correo electónico especificado con un código de verificación, ingrese el código de verificación recibido para continuar con el proceso',
        'CAMBIARMAIL_PASO1_NOTOK': 'No se puede continuar, el correo electrónico ingresado ya se encuentra registrado en el sistema',
        'CAMBIARMAIL_PASO1_SAME': 'No se puede continuar, el correo electónico ingresado es el mismo que tiene la cuenta actualmente',
        'CAMBIARMAIL_PASO2_OK': 'El código de verificación es correcto, para continuar, es necesario que ingrese una nueva contraseña a continuación',
        'CAMBIARMAIL_PASO2_NOTOK': 'El código de verificación es incorrecto, compruebe que lo ingresó correctamete y vuelva a verificarlo',
        'CAMBIARMAIL_PASO3_NOTOK': 'No se puede continuar, las contraseñas no coinciden, vuelva a ingresarlas correctamente',
        'CAMBIARMAIL_PASO3_OK': 'Los datos de la cuenta fueron actualizados correctamente, para finalizar el proceso se cerrará la sesión, vuelva a ingresar a la plataforma usando los nuevos datos de acceso',
        'CAMBIAPASS_OK': 'La contraseña de la cuenta fue actualizada correctamente',
        'CAMBIAPASS_NOTOK': 'No se puede continuar, las contraseñas no coinciden, vuelva a ingresarlas correctamente',
        'AUTHOK': 'Se actualizó el estatus de la autenticación correctamente'
      }
    },
    'PROFILE': {
      'MENU_TITLE':'Cerrar      ',
      'MYPROFILLE':'Mi perfil',
      'TITLE':'Cambiar contraseña',
       'BTNBACK':'Regresar',
       'MENUTITLE':'Menú',
       'MENU':{
         'OPC1':'Mis datos'
       },
       'NAME':'Nombre',
       'EMAIL':'Correo',
       'CODE':'Código de verificación',
       'NEWPASS':'Nueva contraseña',
       'REPASS':'Confirmar contraseña',
       'CHANGE':'Cambiar contraseña',
       'SENDCODE':'Enviar código de verifcación',
       'CHECKCODE':'Verificar código',
       'ERROR':{
         'ERROR01':'Campo necesrio',
         'ERROR02':'Error, algo ocurrio',
         'ERROR03':'El código no coincide',
         'ERROR04':'Las contraseñas no coinciden',
         'ERROR05':'Debe tener 3 caracteres mínimo',
         'ERROR06':'Este correo ya esta registrado, por favor ingrese otro',
         'ERROR07':'El nombre de la empresa no coincide'
       },
       'SUCCESS':{
         'OK':'Ok',
        'MESESAGE1':'Datos actualizados correctamente',
        'MESESAGE2':'Código enviado... Por favor revise su correo',
        'MESESAGE3':'Código correcto'
       }

    },
  }
};
